<template>
  <modal :show.sync="showModal">
    <h6 slot="header" class="modal-title">Crear Equipo</h6>

    
    <!-- Card body -->
    <!--
    <div class="row">
      <div class="col-lg-8">
        <p class="mb-0">
          We recommend using client side validation, but in case you require server side, you can indicate invalid and valid form fields with <code>.is-invalid</code> and <code>.is-valid</code>. Note that <code>.invalid-feedback</code>
          is also supported with these classes.
        </p>
      </div>
    </div>
    <hr>
    -->
    <form class="needs-validation" id="formCreateTeam"
        @submit.prevent="sendForm">
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre"
                      name="nombre"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre')"
                      v-validate="'required'"
                      v-model="model.name">
          </base-input>
        </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Sponsor">
                    <el-select @change="loadSucursalList" v-model="model.sponsor.value" filterable
                                placeholder="Seleccione sponsor">
                        <el-option v-for="option in selectSponsors"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Sucursal">
                    <el-select v-model="model.sucursal.value" filterable
                                placeholder="Seleccione sucursal">
                        <el-option v-for="option in selectSucursales"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formCreateTeam">Guardar Cambios</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>

  </modal>
</template>
<script>
import { Select, Option } from 'element-ui';

  export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
      return {
        validated: false,
        model: {
          name: '',
          sucursal: { label: '', value: ''},
          sponsor: { label: '', value: ''},
        },
        showModal: false,
        selectSucursales: [], // Este debe ser un arreglo de objetos asi: { label: ...(es lo que se ve), value: ...}
        selectSponsors: []
      }
    },
    methods: {
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      sendForm(){
        var vm = this;
        
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          if( response ){
            
            vm.axios({
                method: 'POST',
                url: 'api/store_create_team',
                data: {   
                          nombre: vm.model.name, 
                          sucursal: vm.model.sucursal.value,
                          sponsor: vm.model.sponsor.value
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Equipo creado exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModal = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo almacenar el equipo',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
        }).catch( reason => {
          console.log(reason);
        });
        
      },
      loadSucursalList()
      {
        var vm = this;
        this.axios({
          method: 'POST',
          url: 'api/list_sponsorbranchs_from_sponsor',
          data: {sponsor: this.model.sponsor.value}
        }).then( response => {
          vm.selectSucursales = response.data;
          vm.model.sucursal.value = null;
        }).catch( error => {
          console.log(error);
        }); 
      }
    },
    mounted()
    {
        var vm = this;
        this.axios({
            method: 'GET',
            url: 'api/test_list_sponsors_from_create_team'
        }).then(response => {
            vm.selectSponsors = response.data;

        }).catch( error => {
            console.log(error);
        })
        ;
    },
    created()
    {
      this.$parent.$on('showModalCreateTeam', () => { this.showModal = true; } )
    }
  }
</script>
<style>
</style>
